<section
  class="all-reviews-section"
  [class.is-rtl]="isAr"
  [attr.dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="atw-container">

    <div class="section-title all-reviews-title">
      <span>
        <b>{{ 'atw.reviews.sectionNumber' | transloco }}</b>
      </span>

      <div>
        <h2>{{ 'atw.reviews.title' | transloco }}</h2>
        <p>{{ 'atw.reviews.subtitle' | transloco }}</p>
      </div>
    </div>

    <div class="apply-card all-reviews-card">

      <div class="reviews-head">
        <div>
          <div class="hero-badge reviews-badge">
            <span>{{ 'atw.reviews.badgeNumber' | transloco }}</span>
            {{ 'atw.reviews.badgeTitle' | transloco }}
          </div>

          <h3>{{ 'atw.reviews.heading' | transloco }}</h3>
          <p>{{ 'atw.reviews.description' | transloco }}</p>
        </div>

        <div class="reviews-controls">
          <button
            type="button"
            class="review-nav-btn"
            (click)="prevReviews()"
            [disabled]="isLoading || totalPages <= 1"
            [attr.aria-label]="'atw.reviews.prevLabel' | transloco"
          >
            ‹
          </button>

          <button
            type="button"
            class="review-nav-btn active"
            (click)="nextReviews()"
            [disabled]="isLoading || totalPages <= 1"
            [attr.aria-label]="'atw.reviews.nextLabel' | transloco"
          >
            ›
          </button>
        </div>
      </div>

      <div class="reviews-state" *ngIf="isLoading">
        {{ isAr ? 'جاري تحميل التقييمات...' : 'Loading reviews...' }}
      </div>

      <div class="reviews-state error" *ngIf="!isLoading && errorMessage">
        {{ errorMessage }}
      </div>

      <div
        class="reviews-state empty"
        *ngIf="!isLoading && !errorMessage && visibleReviews.length === 0"
      >
        {{ isAr ? 'لا توجد تقييمات حالياً.' : 'No reviews available yet.' }}
      </div>

      <div
        class="reviews-grid"
        *ngIf="!isLoading && !errorMessage && visibleReviews.length > 0"
      >
        <article
          class="review-card"
          *ngFor="let review of visibleReviews; trackBy: trackByReview"
        >
          <div class="review-top">
            <div class="review-avatar" [class.has-image]="review.imageUrl">
              <img
                *ngIf="review.imageUrl"
                [src]="review.imageUrl"
                [alt]="review.name"
                loading="lazy"
                (error)="onAvatarImageError(review)"
              />

              <span *ngIf="!review.imageUrl">
                {{ review.avatar }}
              </span>
            </div>

            <div>
              <h4>{{ review.name }}</h4>

              <div
                class="review-stars"
                [attr.aria-label]="'Rating ' + review.stars + ' of 5'"
              >
                <span
                  *ngFor="let star of starItems"
                  [class.empty]="star > review.stars"
                >
                  ★
                </span>
              </div>
            </div>
          </div>

          <p class="review-text">
            “{{ review.text }}”
          </p>
        </article>
      </div>

      <div
        class="reviews-dots"
        *ngIf="!isLoading && !errorMessage && visibleReviews.length > 0 && totalPages > 1"
      >
        <button
          type="button"
          *ngFor="let page of pages; let i = index"
          [class.active]="currentPage === i"
          (click)="goToPage(i)"
          [attr.aria-label]="(isAr ? 'صفحة التقييمات ' : 'Review page ') + (i + 1)"
        ></button>
      </div>

    </div>

  </div>
</section>